import React from 'react';
import { MessageCircle } from 'lucide-react';
import { getLineOfficialUrl } from '../../utils/lineOfficial';

const baseClass =
  'inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-colors';

const variants = {
  nav: `${baseClass} bg-[#06C755] px-3 py-2 text-sm text-white hover:bg-[#05b34c] lg:px-4`,
  drawer: `${baseClass} w-full bg-[#06C755] px-4 py-3 text-sm text-white hover:bg-[#05b34c]`,
};

export function LineOfficialLink({ variant = 'nav', className = '', onNavigate }) {
  const href = getLineOfficialUrl();
  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onNavigate}
      className={`${variants[variant] || variants.nav} ${className}`}
    >
      <MessageCircle className="h-4 w-4 shrink-0" />
      <span>ติดต่อ LINE</span>
    </a>
  );
}
